module.exports = __webpack_public_path__ + "media/senhaNova.c2fd3cfb.mp3";